import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Spinner } from "@/components/ui/spinner";
import { environment } from "@/config/env";
import { useEliteReservation } from "@/contexts/EliteTemporaryContextProvider";
import { Label } from "@radix-ui/react-label";
import axios from "axios";
import { ArrowRight } from "lucide-react";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "sonner";
import { useTranslation } from "react-i18next";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";

export default function Kiosk() {
  const { t } = useTranslation();
  useDocumentTitle("Kiosk - Fast Check-in");
  const { structureId } = useParams<{ structureId: string }>();
  const [loading, setLoading] = useState(true);
  const [reservationId, setReservationId] = useState("");
  const [structureLogo, setStructureLogo] = useState<string | null>(null);
  const [structureName, setStructureName] = useState<string | null>(null);
  useEffect(() => {
    if (!structureId) {
      return;
    }
    axios
      .get(`${environment.ELITE_BASE_URI}/structure/${structureId}/logo`)
      .then((response) => {
        // Struttura trovata, puoi procedere con la logica della pagina Kiosk
        setStructureLogo(response.data.logo);
        setStructureName(response.data.name);
      })
      .catch((error) => {
        // Gestisci l'errore se la struttura non viene trovata
        toast.error(t("kiosk.errors.invalidStructureCode"));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [structureId]);
  const handleReservationLookup = () => {
    axios
      .post<{ magicLink: string; fromKiosk: boolean }>(
        `${environment.ELITE_BASE_URI}/kiosk/${structureId}/lookup`,
        {
          reservationId,
        },
      )
      .then((response) => {
        // Reindirizza l'utente al link magico ricevuto
        window.location.href =
          response.data.magicLink +
          (response.data.fromKiosk ? "?fromKiosk=true" : "");
      })
      .catch((error) => {
        // Gestisci l'errore se la prenotazione non viene trovata
        toast.error(t("kiosk.errors.reservationNotFound"));
      });
  };
  return (
    <div className="text-center flex flex-col gap-4 p-12 mx-auto max-w-5xl">
      {!loading && structureId && (
        <>
          {structureLogo && (
            <img
              src={structureLogo}
              alt="Structure Logo"
              className="mx-auto mb-4 max-h-24"
            />
          )}
          {!structureLogo && structureName && (
            <Label className="text-4xl font-bold">{structureName}</Label>
          )}
          <Label className="text-6xl font-bold">{t("kiosk.welcome")}</Label>
          <Label className="text-4xl font-bold">
            {t("kiosk.reservationNumber")}
          </Label>
          <Label className="text-base text-muted-foreground">
            {t("kiosk.reservationInstruction")}
          </Label>
          <Input
            className="text-2xl text-center uppercase p-7"
            onChange={(e) => {
              setReservationId(e.currentTarget.value);
            }}
          />
          <Button
            disabled={reservationId.trim() === ""}
            className="text-md p-6"
            onClick={handleReservationLookup}
          >
            {t("kiosk.goToReservation")}
            <ArrowRight />
          </Button>
        </>
      )}
      {loading && (
        <>
          <div className="flex flex-col justify-center items-center gap-4">
            <Spinner className="size-12" />
            <Label className="text-2xl font-bold">{t("kiosk.loading")}</Label>
          </div>
        </>
      )}
    </div>
  );
}
